import { GETPROJECTS_SUCCESS, GETPROJECTS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getProjectsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETPROJECTS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETPROJECTS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getProjectsReducer;
